import {Component} from "../enum/Component";
import {ValidationUtil} from "./ValidationUtil";
import {LocalStorageUtil} from "./LocalStorageUtil";

export class SignatureUtil {

    public static savePageSignatures(page: number, appData: any, uiSchema: any, schema: any) {
        let pageElements = uiSchema.elements[page].elements;
        for(let pageElement of pageElements) {
            let split = pageElement.scope.split('/');
            let pageKey = split[2];
            let componentKey = split[4];
            let typeKey = split[6];
            if(ValidationUtil.isPropertyOfType(schema.properties[pageKey].properties[componentKey], Component.Signature) &&
                appData[pageKey][componentKey][typeKey] !== undefined &&
                appData[pageKey][componentKey][typeKey] !== ""){
                LocalStorageUtil.setItem(pageElement.scope, appData[pageKey][componentKey][typeKey]);
            }
        }
    }

    public static clearAllPageSignatures(appData: any, uiSchema: any, schema: any) {
        for(let schemaElement of uiSchema.elements) {
            let pageElements = schemaElement.elements;
            for(let pageElement of pageElements) {
                let split = pageElement.scope.split('/');
                let pageKey = split[2];
                let componentKey = split[4];
                if(ValidationUtil.isPropertyOfType(schema.properties[pageKey].properties[componentKey], Component.Signature)){
                    LocalStorageUtil.removeItem(pageElement.scope);
                }
            }
        }
    }

    public static getExistingSignature(componentKey: string){
        return LocalStorageUtil.getItem(componentKey);
    }

    public static removeExistingSignature(componentKey: string){
        return LocalStorageUtil.removeItem(componentKey);
    }



}
